<template>
  <div>
    <span
      class="d-inline-block"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      :title="'พิมพ์ใบส่งสินค้า'"
    >
      <button
        :class="btnClass"
        v-bind="$attrs"
        @click="PrintAndSetShipmentData"
      >
        <span class="position-relative font-smaller" tabindex="-1">
          <i class="fa fa-print"
            :style="[btnClass!='btn btn-link btn-sm ' ? 'color: #fff' : '']"></i>

          <span
            v-if="printNumShow > 0"
            class="position-absolute top-0 start-200 translate-middle badge rounded-pill">
            {{printNumShow}}
          </span>
        </span>
      </button>
    </span>

    
    <pdf-viewer ref="pdfViewerRef"></pdf-viewer>
  </div>
  
</template>


<script>

import PdfViewer from "../modals/forms/PdfViewer.vue";
import ApiService from "../../core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  components: { PdfViewer },
  props: {
    uoRefNo: String,
    shipmentCode:String,
    partnerCode: String,
    class:String,
    printNum:Number
  },
  data() {
    return {
      btnClass:"btn btn-link btn-sm ms-5",
      printNumShow:0
    };
  },
  mounted(){
     if(this.class){
        this.btnClass = this.class;
     }
     this.printNumShow = this.printNum;
    
  },
  methods: {
    PrintAndSetShipmentData: async function () {

      const loader = this.$loading.show();
      try {
        var tempData;
          // const { data } = await ApiService.post("Orders/AddShipmentData", {
          //   uoRefNo:this.uoRefNo,
          //   // productSelected:this.productSelected
          // });
          // tempData = data;
          // // this.$swal("สำเร็จ", "บันทึกข้อมูลส่งสินค้าแล้ว", "success");
          // this.$emit("update");
          await ApiService.post("Orders/UpdatePrintNum", {
            shipmentCode:this.shipmentCode,
            // productSelected:this.productSelected
          }).then(res => {
             this.printNumShow = res.data;
            //console.log("res",res);
            this.$emit("refresh");
            this.pdf();
          });
          
  
          
          
      } catch (error) {
        Swal.fire({
          text: "เกิดข้อผิดพลาด ไม่สามารถบันทึกข้อมูลได้!",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ปิด",
          allowOutsideClick: false,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then(() => {
          //this.hide();
        });
      }
      this.btnLoading = false;
      loader.hide();

    }, 
    pdf() {
      // console.log(this.uoRefNo);
      // this.$emit("update");
      let url = "pdf/delivery/orderfrom2s/" + this.uoRefNo

      if(this.partnerCode ) {
        url = "pdf/delivery/orderfrom2s/" + this.partnerCode + "/" + this.uoRefNo;
      }

      this.$http
        .get(url, {
          responseType: "blob",
        })
        .then((res) => {
          //console.log(res, res.data);
          var file = new Blob([res.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);
          //window.open(fileURL);
          //this.$emit("viewShow")
          this.$refs.pdfViewerRef.show({ url: fileURL });
        });
      
    },
  }
}
</script>
<style scoped>
  .btn-green {
    color: #fff;
    background-color: #35a5b6;
    border-color: #117a8b;
  }
  .btn-dark-green {
      color: #fff;
      background-color: #066f8f;
  }
</style>